import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react';
import { Form, Input } from 'antd'
import { ControlElement, ControlProps as JSFControlProps } from '@jsonforms/core';
import type { Rule } from "antd/es/form"
import { AppControlUISchema } from '../form-types';
import WithLabel from '../../ui/WithLabel/WithLabel';
import { FormIcon } from '../icon';
import { useFormValue } from '../hooks/useFormValue';

type ControlProps = Omit<JSFControlProps, "uischema"> & {
  data: string
  handleChange(path: string, value: string): void
  path: string
  uischema: AppControlUISchema<unknown> | ControlElement
}

const TextControl: React.FC<ControlProps> = ({
  label,
  data,
  path,
  enabled,
  required,
  schema,
  uischema,
  handleChange
}) => {
  const { default: defaultValue, minLength, maxLength } = schema ?? {};
  const { columns = 1, placeholder, type, icon, extraRules } = uischema.options ?? {};

  const isMultiLineControl = type === 'multiline';

  const rules: Rule[] = [
    ...(required  ? [{ required: true, message: `${label} is required` }] : []),
    ...(minLength ? [{ min: minLength, message: `${label} must be at least ${minLength} characters` }] : []),
    ...(maxLength ? [{ max: maxLength, message: `${label} must be at most ${maxLength} characters` }] : []),
    ...(extraRules ?? [])
  ];

  const initialData = useFormValue({
    path,
    value: data,
    initialValue: data || defaultValue || null,
    handleChange
  });

  return (
    <Form.Item
      rules={rules}
      initialValue={initialData}
      name={path}
      validateTrigger='onSubmit'
      validateFirst
      style={{
        gridColumn: `span ${columns}`,
      }}
      getValueFromEvent={(e) => {
        const value = e?.target?.value;
        handleChange(path, value);
        return value;
      }}
    >
      <WithLabel
        icon={<FormIcon name={icon} size={18} />}
        label={label}
        required={required}
      >
        {isMultiLineControl ? (
          <Input.TextArea
            value={data ?? ''}
            aria-label={label || schema.description}
            disabled={!enabled}
            autoComplete="off"
            placeholder={placeholder}
          />
        ) : (
          <Input
            value={data ?? ''}
            aria-label={label || schema.description}
            disabled={!enabled}
            autoComplete="off"
            placeholder={placeholder}
          />
        )}

      </WithLabel>
    </Form.Item>
  )
};

export default withJsonFormsControlProps(TextControl as any);
